export default function ({ store, redirect, route }) {
    // Skip this middleware if we're already on one of the actual checkout pages
    const user = store.state.auth.user;

    // Route to new checkout if:
    // 1. User is not logged in, or
    // 2. User doesn't have a corporate account, or
    // 3. User has no previous orders

    if (route.name === 'CheckoutRedirect' || route.name === 'checkout-redirect') {
  

    if (!user || !user.corporate_account) {
        return redirect('/checkout-new');
    } else {
            // Otherwise, route to the old checkout
            return redirect('/checkout');
        }
    }
}
